import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { testimonials, statsData } from '@/mocks/resources';
import { getFormUrl } from '@/pages/about/utils';

export default function AboutPage() {
  const [activeTab, setActiveTab] = useState('intro');

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '老六资源库',
    url: 'https://laoliu-resource.com',
    description: '老六资源库是专为资源爱好者打造的一站式资源聚合平台，涵盖学习资料、工具软件、影音素材等海量优质内容。免费分享，持续更新。',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <Navbar />
      <main className="pt-16">
        <section className="relative w-full h-[260px] md:h-[320px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20modern%20office%20interior%20with%20team%20collaboration%20space%2C%20natural%20sunlight%2C%20cream%20and%20beige%20walls%2C%20indoor%20plants%2C%20clean%20aesthetic%2C%20warm%20ambient%20tones%2C%20editorial%20style%2C%20simple%20composition&width=1800&height=800&seq=about-hero-01&orientation=landscape"
            alt="关于老六资源库"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-2xl md:text-4xl font-bold text-white font-heading">
              关于我们
            </h1>
          </div>
        </section>

        <div className="px-4 md:px-6 py-4 bg-background-50 border-b border-background-200/70">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        <div className="px-4 md:px-6 bg-background-50 border-b border-background-200/70">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center gap-1 py-1">
              {[
                { key: 'intro', label: '品牌介绍' },
                { key: 'reputation', label: '口碑评价' },
                { key: 'contact', label: '联系我们' },
              ].map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`px-5 py-2.5 text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer ${
                    activeTab === tab.key
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-600 hover:text-foreground-800'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-4xl mx-auto">
            {activeTab === 'intro' && (
              <div className="animate-fade-in">
                <article>
                  <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-6 font-heading">
                    关于老六资源库
                  </h2>
                  <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                    <p>
                      <strong>老六资源库</strong>创建于2022年，是一个致力于为广大资源爱好者提供<strong>优质免费资源</strong>的一站式聚合平台。我们深知在海量信息中寻找可靠资源的困难，因此精心筛选、整理和分类各类资源，让每一位访问者都能高效获取所需内容。
                    </p>
                    <p>
                      平台目前涵盖<strong>学习资料、工具软件、影音素材、设计资源、电子书籍、实用模板</strong>等六大核心分类，累计收录资源超过11,200个，累计下载量突破58万次，服务超过9.6万名活跃用户。
                    </p>
                    <p>
                      我们的团队由一群热爱分享的年轻人组成，分布在<strong>内容审核、资源整理、技术开发、用户运营</strong>等关键岗位。大家怀揣着「让优质资源触手可及」的共同愿景，日复一日地为平台贡献着自己的力量。
                    </p>
                  </div>

                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
                    {statsData.map((stat) => (
                      <div key={stat.label} className="text-center p-5 bg-background-100 rounded-lg border border-background-200/70">
                        <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                          <i className={`${stat.icon} text-lg`}></i>
                        </div>
                        <div className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                          {stat.value}
                        </div>
                        <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                      </div>
                    ))}
                  </div>

                  <h3 className="text-lg md:text-xl font-bold text-foreground-900 mt-10 mb-4 font-heading">
                    我们的愿景
                  </h3>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                    打造中文互联网<strong>最值得信赖</strong>的免费资源分享平台，让每个人都能平等地获取知识和工具，消除信息壁垒，推动知识共享。
                  </p>

                  <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-4 font-heading">
                    核心价值
                  </h3>
                  <ul className="space-y-3">
                    {[
                      { icon: 'ri-checkbox-circle-line', text: '完全免费：所有资源永久免费提供，不设置任何付费墙' },
                      { icon: 'ri-shield-check-line', text: '安全可靠：每份资源经过人工安全审核，确保无毒无害' },
                      { icon: 'ri-refresh-line', text: '持续更新：保持高频更新节奏，第一时间收录优质新资源' },
                      { icon: 'ri-user-heart-line', text: '用户至上：倾听用户反馈，不断优化资源质量和平台体验' },
                    ].map((item, index) => (
                      <li key={index} className="flex items-start gap-3 text-sm md:text-base text-foreground-700">
                        <i className={`${item.icon} text-primary-500 mt-0.5 flex-shrink-0`}></i>
                        <span>{item.text}</span>
                      </li>
                    ))}
                  </ul>
                </article>
              </div>
            )}

            {activeTab === 'reputation' && (
              <div className="animate-fade-in">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-6 font-heading">
                  用户口碑
                </h2>
                <p className="text-sm md:text-base text-foreground-600 mb-8">
                  听听大家怎么说 —— 来自真实用户的使用体验和评价
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                  {testimonials.map((item, index) => (
                    <div
                      key={index}
                      className="p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/70"
                    >
                      <div className="flex items-center gap-3 mb-4">
                        <img
                          src={item.avatar}
                          alt={item.name}
                          className="w-11 h-11 rounded-full object-cover"
                        />
                        <div>
                          <div className="text-sm font-semibold text-foreground-800">{item.name}</div>
                          <div className="text-xs text-foreground-500">{item.role}</div>
                        </div>
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed">
                        &ldquo;{item.content}&rdquo;
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'contact' && (
              <div className="animate-fade-in">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-6 font-heading">
                  联系我们
                </h2>
                <p className="text-sm md:text-base text-foreground-600 mb-8">
                  有任何问题、建议或资源推荐，欢迎通过以下方式联系我们
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                  <div className="space-y-4">
                    <div className="flex items-start gap-3 p-4 bg-background-100 rounded-lg">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                        <i className="ri-mail-line text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h4>
                        <p className="text-sm text-foreground-600">laoliu_resource@163.com</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3 p-4 bg-background-100 rounded-lg">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                        <i className="ri-wechat-line text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-800 mb-1">微信公众号</h4>
                        <p className="text-sm text-foreground-600">老六资源库</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-3 p-4 bg-background-100 rounded-lg">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                        <i className="ri-weibo-line text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-800 mb-1">微博</h4>
                        <p className="text-sm text-foreground-600">@老六资源库</p>
                      </div>
                    </div>
                  </div>

                  <ContactForm />
                </div>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}

function ContactForm() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypot = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const formData = new FormData(form);
      const submitAddr = form.getAttribute('action') || '';
      const response = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败';
        setFormError(serverMsg.includes('spam') ? '提交失败，请稍后重试' : serverMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <div className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70">
      <h3 className="text-base font-semibold text-foreground-800 mb-4">发送消息</h3>
      {formStatus === 'success' ? (
        <div className="text-center py-8">
          <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
            <i className="ri-check-line text-2xl"></i>
          </div>
          <p className="text-sm text-foreground-700 font-medium">消息已发送成功！</p>
          <p className="text-xs text-foreground-500 mt-1">我们会尽快回复您</p>
        </div>
      ) : (
        <form ref={formRef} onSubmit={handleSubmit} action={getFormUrl()} className="flex flex-col gap-3" data-readdy-form="">
          <input
            type="text"
            name="name"
            placeholder="您的称呼"
            required
            className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md outline-none focus:border-primary-400 transition-colors"
          />
          <input
            type="email"
            name="email"
            placeholder="电子邮箱"
            required
            className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md outline-none focus:border-primary-400 transition-colors"
          />
          <textarea
            name="message"
            placeholder="请输入您的留言..."
            rows={4}
            maxLength={500}
            required
            className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-md outline-none focus:border-primary-400 transition-colors resize-none"
          ></textarea>
          <input
            type="text"
            name="phone_alt"
            className="hp-field"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          {formError && (
            <p className="text-xs text-red-500">{formError}</p>
          )}
          <button
            type="submit"
            disabled={formStatus === 'loading'}
            className="w-full py-2.5 bg-primary-500 text-white text-sm font-medium rounded-md hover:bg-primary-600 transition-colors disabled:opacity-60 cursor-pointer whitespace-nowrap"
          >
            {formStatus === 'loading' ? '发送中...' : '发送消息'}
          </button>
        </form>
      )}
    </div>
  );
}